import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TContext } from '../context.types'

function setContext(state: TContext | null, action: PayloadAction<TContext>): TContext {
  return action.payload
}
function updateContext(state: TContext | null, action: PayloadAction<Partial<TContext>>): TContext | null {
  if (!state) return null

  return {
    ...state,
    ...action.payload
  }
}

export default createSlice({
  name: 'appContext',
  initialState: null as TContext | null,
  reducers: {
    setContext,
    updateContext
  }
})
